const mobilemenuiconfolder = '/assets/images/bottom-menu/';
const menuionsfolder = '/assets/dashboard/';
export const MAINMENU = [{
    menu_name: 'Update Profile',
    menu_link: '/update_profile',
    menu_icon: `${menuionsfolder}updateprofile.svg`,
},
{
    menu_name: 'Subscription Info',
    menu_link: '/subscription',
    menu_icon: `${menuionsfolder}payment method.svg`,
},
{
    menu_name: 'Contact Us',
    menu_link: 'javascript:;',
    contact_pop: true,
    menu_icon: `${menuionsfolder}contactus.svg`,
},
{
    menu_name: 'Leads',
    menu_link: '/partnerviewleads',
    contact_pop: false,
    menu_icon: `${menuionsfolder}leads.png`,
},
];
export const SECONDMENU = [{
    menu_name: 'Account Info',
    menu_link: '/homepage',
},
{
    menu_name: 'Branch – Add/View',
    menu_link: '/branch',
    isbranch: true,
},
{
    menu_name: 'Dashboard',
    menu_link: '/dashboards',
},
{
    menu_name: 'Reports',
    menu_link: '/reports',
},
{
    menu_name: 'Parent Feedback and Interactions',
    menu_link: '/review',
},
{
    menu_name: 'Latest News',
    menu_link: '/news',
},
{
    menu_name: 'Exclusive Partnerships',
    menu_link: '/exclusive_partnerships',
},
{
    menu_name: 'Benchmarking',
    menu_link: '/bench_mark',
},
{
    menu_name: 'Job Posting',
    menu_link: '/job_posting',
},
];
export const MOBILEMENU = [
    {
        menu_name: 'Account Info',
        menu_link: '/homepage',
        isbranch: true,
        menu_icon: `${mobilemenuiconfolder}btm-mn-account.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-account.png`,
    },
    {
        menu_name: 'Dashboard',
        menu_link: '/dashboards',
        menu_icon: `${mobilemenuiconfolder}btm-mn-dashboard.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-dashboard.png`,
    },
    {
        menu_name: 'Review',
        menu_link: '/review',
        menu_icon: `${mobilemenuiconfolder}btm-mn-feedback.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-feedback.png`,
    },
    {
        menu_name: 'Benchmarking',
        menu_link: '/bench_mark',
        menu_icon: `${mobilemenuiconfolder}btm-mn-benchmarking.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-benchmarking.png`,
    },
    {
        menu_name: 'Branch – Add/View',
        menu_link: '/branch',
        isbranch: true,
        menu_icon: `${mobilemenuiconfolder}btm-mn-branch.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-branch.png`,
    },
    {
        menu_name: 'Report',
        menu_link: '/reports',
        menu_icon: `${mobilemenuiconfolder}btm-mn-reports.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-reports.png`,
    },
    {
        menu_name: 'Latest News',
        menu_link: '/news',
        menu_icon: `${mobilemenuiconfolder}btm-mn-newsarticles.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-news.png`,
    },
    {
        menu_name: 'Excl Partnerships',
        menu_link: '/exclusive_partnerships',
        menu_icon: `${mobilemenuiconfolder}btm-mn-exclpartner.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-exclpartner.png`,
    },
    {
        menu_name: 'Job Posting',
        menu_link: '/job_posting',
        menu_icon: `${mobilemenuiconfolder}btm-mn-jobposting.png`,
        menu_icon_active: `${mobilemenuiconfolder}btm-mn-dark-jobposting.png`,
    }
];
export const SECONDMENUMOB = [
    {
        menu_name: 'Update Profile',
        menu_link: '/update_profile',
    },
    {
        menu_name: 'Subscription Info',
        menu_link: '/subscription',
    },
    {
        menu_name: 'Contact Us',
        menu_link: 'javascript:;',
        contact_pop: true
    },
    {
        menu_name: 'Log out',
        menu_link: 'javascript:;',
        logout: true
    },
];


// WEBPACK FOOTER //
// ./src/components/bewise/partners/partnerconstant.js